module.exports = __webpack_public_path__ + "static/media/progress_zusammenfassung.5639ec11.svg";